/** Same source as Collab workspace intro; override via env in build. */
export const COLLAB_INTRO_VIDEO_URL =
  process.env.REACT_APP_COLLAB_INTRO_VIDEO_URL ||
  'https://plxuc9elglrdwhhs.public.blob.vercel-storage.com/jamie.mp4';
